import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faLaptopCode, faServer } from '@fortawesome/free-solid-svg-icons';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1 className="about-title">Sobre Mí</h1>
        <div className="about-line"></div>
      </div>

      <div className="about-content">
        <div className="about-text">
          <p>
            ¡Hola! Soy un desarrollador web fullstack apasionado por crear soluciones
            digitales intuitivas y de alto rendimiento. Con experiencia en el desarrollo
            de aplicaciones web y móviles, me especializo en transformar ideas en productos
            funcionales y elegantes.
          </p>
          <p>
            Mi enfoque se centra en el usuario, buscando siempre la mejor experiencia
            posible combinada con código limpio y bien estructurado. Me encanta aprender
            nuevas tecnologías y estar al día con las tendencias del desarrollo web.
          </p>
          <p>
            Cuando no estoy programando, disfruto de la música, los videojuegos y explorar
            nuevos lugares. Siempre estoy abierto a nuevas oportunidades y colaboraciones.
          </p>
        </div>

        <div className="skills-container">
          <h2>Mis Habilidades</h2>
          
          <div className="skills-grid">
            <div className="skill-card">
              <FontAwesomeIcon icon={faCode} className="skill-icon" />
              <h3>Frontend</h3>
              <p>React, Angular, JavaScript, TypeScript, Responsive Design, Bootstrap, CSS3</p>
            </div>
            
            <div className="skill-card">
              <FontAwesomeIcon icon={faServer} className="skill-icon" />
              <h3>Backend</h3>
              <p>Node.js, PHP, Symfony, Laravel, Wordpress, Java, C#, SQL, MySQL, MongoDB, Elasticsearch</p>
            </div>
            
            <div className="skill-card">
              <FontAwesomeIcon icon={faLaptopCode} className="skill-icon" />
              <h3>Herramientas</h3>
              <p>Git, GitHub, Jira, Trello, Slack, Confluence, Postman, Powershell, Docker, Docker Compose, Kubernetes, AWS</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 